import { render, staticRenderFns } from "./ViewExpenses.vue?vue&type=template&id=2b18401a&scoped=true&"
import script from "./ViewExpenses.vue?vue&type=script&lang=js&"
export * from "./ViewExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b18401a",
  null
  
)

export default component.exports